// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICustomPageable } from './ICustomPageable';
import {
    ICustomPageableFromJSON,
    ICustomPageableFromJSONTyped,
    ICustomPageableToJSON,
    ICustomPageableToJSONTyped,
} from './ICustomPageable';
import type { IInvoiceDashboardAggregatorDto } from './IInvoiceDashboardAggregatorDto';
import {
    IInvoiceDashboardAggregatorDtoFromJSON,
    IInvoiceDashboardAggregatorDtoFromJSONTyped,
    IInvoiceDashboardAggregatorDtoToJSON,
    IInvoiceDashboardAggregatorDtoToJSONTyped,
} from './IInvoiceDashboardAggregatorDto';

/**
 * 
 * @export
 * @interface IInvoiceDashboardPageDto
 */
export interface IInvoiceDashboardPageDto {
    /**
     * 
     * @type {number}
     * @memberof IInvoiceDashboardPageDto
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof IInvoiceDashboardPageDto
     */
    size?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IInvoiceDashboardPageDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IInvoiceDashboardPageDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IInvoiceDashboardPageDto
     */
    empty?: boolean;
    /**
     * 
     * @type {Array<IInvoiceDashboardAggregatorDto>}
     * @memberof IInvoiceDashboardPageDto
     */
    content?: Array<IInvoiceDashboardAggregatorDto>;
    /**
     * 
     * @type {ICustomPageable}
     * @memberof IInvoiceDashboardPageDto
     */
    pageable?: ICustomPageable;
    /**
     * 
     * @type {number}
     * @memberof IInvoiceDashboardPageDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IInvoiceDashboardPageDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IInvoiceDashboardPageDto
     */
    total_elements?: number;
}

/**
 * Check if a given object implements the IInvoiceDashboardPageDto interface.
 */
export function instanceOfIInvoiceDashboardPageDto(value: object): value is IInvoiceDashboardPageDto {
    return true;
}

export function IInvoiceDashboardPageDtoFromJSON(json: any): IInvoiceDashboardPageDto {
    return IInvoiceDashboardPageDtoFromJSONTyped(json, false);
}

export function IInvoiceDashboardPageDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInvoiceDashboardPageDto {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'] == null ? undefined : json['number'],
        'size': json['size'] == null ? undefined : json['size'],
        'last': json['last'] == null ? undefined : json['last'],
        'first': json['first'] == null ? undefined : json['first'],
        'empty': json['empty'] == null ? undefined : json['empty'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IInvoiceDashboardAggregatorDtoFromJSON)),
        'pageable': json['pageable'] == null ? undefined : ICustomPageableFromJSON(json['pageable']),
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
    };
}

export function IInvoiceDashboardPageDtoToJSON(json: any): IInvoiceDashboardPageDto {
    return IInvoiceDashboardPageDtoToJSONTyped(json, false);
}

export function IInvoiceDashboardPageDtoToJSONTyped(value?: IInvoiceDashboardPageDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'last': value['last'],
        'first': value['first'],
        'empty': value['empty'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IInvoiceDashboardAggregatorDtoToJSON)),
        'pageable': ICustomPageableToJSON(value['pageable']),
        'totalPages': value['total_pages'],
        'numberOfElements': value['number_of_elements'],
        'totalElements': value['total_elements'],
    };
}

